import FastImage from 'react-native-fast-image';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import {OverlayModal} from '../../OverlayModal';
import {Dimensions, Platform} from 'react-native';
const { height } = Dimensions.get('window');

//@ts-ignore
export const Container = styled(OverlayModal)`
  justify-content: flex-end;
  margin: 0;
`;

export const ContainerImage =
  Platform.OS === 'web'
    ? styled.TouchableOpacity`
        position: absolute;
        left: 0;
        right: 0;
        bottom: calc(50%);
        z-index: 3;
      `
    : styled.TouchableOpacity`
        z-index: 1;
      `;
const {width: screenWidth, height: screenHeight} = Dimensions.get('screen');

const aspectRatio = screenHeight / screenWidth;

const getSwiperHeight = () => {
  if (screenWidth >= 440) {
    return RFValue(205);
  }

  if (screenWidth >= 411) {
    if (aspectRatio >= 2.2) {
      return RFValue(202);
    }
    if (aspectRatio >= 2.1) {
      return RFValue(216);
    }
    if (aspectRatio >= 1.9) {
      return RFValue(216);
    }
    return RFValue(216);
  }

  if (screenWidth > 375) {
    if (aspectRatio <= 2.1) {
      return RFValue(209);
    }

    if (aspectRatio >= 2.2) {
      return RFValue(190);
    }
    return RFValue(209);
  }

  if (screenWidth > 360) {
    if (aspectRatio >= 2.1) {
      return RFValue(175);
    }
    if (aspectRatio >= 1.9) {
      return RFValue(185);
    }
    return RFValue(232);
  }

  if (aspectRatio >= 2.1) {
    return RFValue(195);
  }
  if (aspectRatio >= 1.9) {
    return RFValue(205);
  }
  return RFValue(262);
};

export const BenefitsBanner = styled(FastImage)`
  width: ${Dimensions.get('window').width}px;
  height: ${getSwiperHeight()}px;
`;
export const BuyAgainContainer = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const BuyAgainContent = styled.View`
  flex-direction: row;
  flex: 1;
  align-items: center;
`;

//@ts-ignore
export const BuyAgainImage = styled(FastImage)`
  height: ${RFValue(40)}px;
  width: ${RFValue(40)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(12)}px;
`;

export const BuyAgainInfos = styled.View`
  margin-left: ${RFValue(8)}px;
  flex: 1;
`;

export const LinkButtonContainer = styled.View`
  flex-direction: row;
`;

export const BuyAgainRegion = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;
export const BuyAgainName = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;

  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const BuyAgainPriceContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const BuyAgainPrice = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;

  margin-right: ${RFValue(4)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

//@ts-ignore
export const RankBadge = styled(FastImage)`
  width: ${RFValue(24)}px;
  height: ${RFValue(24)}px;
`;

export const ModalTitle = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;

  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const ModalFooter = styled.View`
  margin-top: ${RFValue(12)}px;
  width: 100%;
`;

export const ModalHeader = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const ModalContent = styled.View`
  margin-top: ${Platform.OS === 'android' ? RFValue(-20) : RFValue(-24)}px;
  background-color: ${({theme}) => theme.colors.background};
  padding: ${RFValue(18)}px 24px;
  padding-top: ${RFValue(12)}px;
  max-height: ${height * 0.4}px;
`;

export const Content = styled.View`
  max-height: 50%;
  justify-content: space-between;
`;
export const ContentTitles = styled.View`
  padding: 0 24px;
`;
export const ContentExplication = styled.ScrollView`
  max-height: 100%;
`;
export const Section = styled.View`
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  margin: 0 -24px;
  padding: 0 24px;
  padding-bottom: ${RFValue(20)}px;
  margin-bottom: ${RFValue(20)}px;
`;
export const Item = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${RFValue(12)}px;
`;
export const ItemTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;
export const ItemName = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  align-items: center;
`;
export const CheckRateTextBold = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  margin-bottom: ${RFValue(5)}px;
`;

export const TitleCheckRateTextBold = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  margin-bottom: ${RFValue(12)}px;
`;
export const CheckRateText = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  margin-bottom: ${RFValue(10)}px;
`;
export const BuyAgainList = styled.View`
  margin-top: ${RFValue(12)}px;
  padding-top: ${RFValue(12)}px;
  border-style: solid;
  border-top-width: 1px;
  border-color: ${({theme}) => theme.colors.border};

  margin-bottom: ${RFValue(12)}px;
  padding-bottom: ${RFValue(6)}px;
  border-style: solid;
  border-bottom-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
`;

export const BuyAgainListItem = styled.View`
  margin-bottom: ${RFValue(6)}px;
`;

export const BuyAgainListItemTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const BuyAgainListItemText = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const BuyAgainTotalContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const BuyAgainTotalTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const BuyAgainTotalText = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const BuyAgainButton = styled.TouchableOpacity`
  height: ${RFValue(22)}px;
  border-radius: ${RFValue(8)}px;
  justify-content: center;
  padding: 0 ${RFValue(14)}px;
  align-items: center;
  background-color: ${({theme}) => theme.colors.black};
  border: 1px solid ${({theme}) => theme.colors.black};
`;

export const BuyAgainButtonText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const Form = styled.View``;
export const FormControl = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const FormGrid = styled.View`
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

export const RouletteBanner = styled.TouchableOpacity`
  width: 100%;
  height: ${RFValue(40)}px;
  border-radius: ${RFValue(8)}px;
  background-color: ${({theme}) => theme.colors.purple};
  margin-bottom: ${RFValue(6)}px;
`;
